import { UserShort } from '@root/entities/user-short'

import type { AvatarsHost } from '@root/shared/models'

export interface CommentAuthorDto extends UserShort.UserShortDto {}
export interface CommentAuthor extends UserShort.UserShort {}

export function fromDto(
  dto: CommentAuthorDto,
  options: {
    avatarsHost: AvatarsHost
  },
): CommentAuthor {
  return UserShort.fromDto(dto, options.avatarsHost)
}
